import { RTKStoreProvider } from 'gtx-react/rtk/components/RTKStoreProvider';
import { GtxPageWithStore, GtxReactPage } from './GtxApp';
import { Loader } from 'gtx-react/components';
import { Error } from 'gtx-react/components/Error/Error';
import { RTKNotify } from 'gtx-react/rtk/components/RTKNotify';
import { Loader as RtkLoader } from '../../rtk/components/Loader';
import { GtxAppContainer } from './GtxAppContainer';
import { DefaultTopHeaderPortal } from './DefaultTopHeaderPortal';

const isGtxPageWithStore = (page: GtxReactPage): page is GtxPageWithStore => {
    return !!(page as GtxPageWithStore).store;
};

const LoadingPage = ({ hideHeader }) => (
    <>
        {!hideHeader && <DefaultTopHeaderPortal />}
        <Loader loading={true} />
    </>
);

/**
 * Creates an outer wrapper for the page.
 * This wrapper is used to provide the necessary context and providers for the page.
 * It checks if the page has a redux store and wraps it with the appropriate provider.
 */
export const createOuterWrapper = (
    page: GtxReactPage,
    setInitialData: (data: unknown) => void,
    hideHeader: boolean
) => {
    const OuterWrapper = ({ children }: { children: React.ReactNode }) =>
        isGtxPageWithStore(page) ? (
            <RTKStoreProvider
                store={page.store}
                loading={<LoadingPage hideHeader={hideHeader} />}
                error={<Error />}
                initFunc={page.initFunc}
            >
                <RTKNotify />
                {children}
                <RtkLoader />
            </RTKStoreProvider>
        ) : (
            <GtxAppContainer
                loading={<LoadingPage hideHeader={hideHeader} />}
                error={<Error />}
                initFunc={page.initFunc}
                setInitialData={setInitialData}
            >
                {children}
            </GtxAppContainer>
        );

    return OuterWrapper;
};
